import React from "react"
import PropTypes from "prop-types"
import Backdrop from "@material-ui/core/Backdrop"
import CircularProgress from "@material-ui/core/CircularProgress"
import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}))

const propTypes = {
  open: PropTypes.bool.isRequired,
}

const Loading = (props) => {
  const classes = useStyles()
  const { open } = props

  return (
    <div>
      <Backdrop className={classes.backdrop} open={open}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  )
}

Loading.propTypes = propTypes

export default Loading
